import { Text } from '../../primitives/Text';
import { cn } from '../../utils/cn';

export interface SignInWaitNoticeProps {
  /** Pre-translated: `auth.errors.rateLimitedRetrying` with the seconds left. */
  label: string;
  className?: string;
  testID?: string;
}

/**
 * The line a sign-in surface shows while a rate-limited request is being
 * waited out and retried (`waitOutRateLimit` / `useRateLimitWait`). Muted, not
 * red: nothing has failed — the CTA keeps its spinner and the request goes
 * again on its own. Web's AuthCard and the app's sign-in sheet both render it.
 */
export function SignInWaitNotice({ label, className, testID }: SignInWaitNoticeProps) {
  return (
    <Text
      className={cn(
        'text-center text-b2 font-medium text-secondary-400 native:font-mona-medium',
        className,
      )}
      testID={testID}
      webProps={{ role: 'status', 'aria-live': 'polite' }}
      nativeProps={{ accessibilityLiveRegion: 'polite' }}>
      {label}
    </Text>
  );
}
